import { Component } from '@angular/core';

@Component({
  selector: 'rr-questionmark-circel-icon',
  templateUrl: './questionmark-circel-icon.component.html',
  styleUrls: ['./questionmark-circel-icon.component.scss'],
})
export class QuestionmarkCircelIconComponent {
  constructor() {}
}
